import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { Modal, Select, Button, Group, Text, Radio, Divider, Table, Pagination, ActionIcon } from '@mantine/core';
import { IconHelp, IconClockHour4, IconX } from '@tabler/icons-react';
import ReactDOM from 'react-dom';
import TestsApi from "../../api/TestsApi";
import { notifications } from '@mantine/notifications';
import { SelectTimePicker, SelectTooltip, VisiLoader } from "../GeneralComponent/GeneralComponent";

export function Logs({ selectedMemberWebsite, pageId, funnelId, testStartDate, isConversionLogsModalOpen, onConversionLogsClose, TestOptimizeReport }:any) {
  const navigate = useNavigate();
  const [conversionLogsConversionType, setConversionLogsConversionType] = useState([]);
  const [conversionLogsGoalList, setConversionLogsGoalList] = useState([]);
  const [conversionLogsPostbackList, setConversionLogsPostbackList] = useState([]);
  const [conversionLogsWebhookList, setConversionLogsWebhookList] = useState([]);
  const [conversionLogsVariationList, setConversionLogsVariationList] = useState([]);
  const [conversionType, setConversionType] = useState('');
  const [conversionTypeName, setConversionTypeName] = useState('');
  const [goalList, setGoalList] = useState('');
  const [goalListName, setGoalListName] = useState('');
  const [postbackList, setPostbackList] = useState('');
  const [webhookList, setWebhookList] = useState('');
  const [variationList, setVariationList] = useState('all');
  const [, setPostbackListName] = useState('');
  const [, setWebhookListName] = useState('');
  const [convLogRedioBtn, setConvLogRedioBtn] = useState('goal');
  const [filterConversionLog, setFilterConversionLog] = useState('no');
  const [undefinedConversionTableField, setUndefinedConversionTableField] = useState<string[]>([]);
  const [undefinedConversionTableData, setUndefinedConversionTableData] = useState<any[]>([]);
  const [conversionTypeStatus, setConversionTypeStatus] = useState('');
  const [definedConversionTableField, setDefinedConversionTableField] = useState<string[]>([]);
  const [definedConversionTableData, setDefinedConversionTableData] = useState<any[]>([]);
  const [resetConversionTableField, setResetConversionTableField] = useState<string[]>([]);
  const [resetConversionTableData, setResetConversionTableData] = useState<any[]>([]);
  const [recordUniqueConversionTableField, setRecordUniqueConversionTableField] = useState<string[]>([]);
  const [recordUniqueConversionTableData, setRecordUniqueConversionTableData] = useState<any[]>([]);
  const [webhookDefinedConversionTableField, setWebhookDefinedConversionTableField] = useState<string[]>([]);
  const [webhookDefinedConversionTableData, setWebhookDefinedConversionTableData] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(15);
  const [activePageNo, setActivePageNo] = useState(1);
  const [totalPaginationNo, setTotalPaginationNo] = useState(1);
  const [trafficControlLogsData, setTrafficControlLogsData] = useState<any[]>([]);

  const [selectedTimePicker, setSelectedTimePicker] = useState('');
  const [selectedTimePickerToDate, setSelectedTimePickerToDate] = useState('');
  const [selectedTimePickerFromDate, setSelectedTimePickerFromDate] = useState('');

  const logsRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const [isVisiLoaderVisible, setIsVisiLoaderVisible] = useState(false);

  useEffect(() => {
    if (isConversionLogsModalOpen) {
      if (!pageId) {
        navigate('/review-tests');
        return;
      }
      setIsVisiLoaderVisible(true);
      TestsApi.getconversionlogdetails({
        system_website_id: selectedMemberWebsite,
        page_id:pageId,
        funnel_id:funnelId
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
            setIsVisiLoaderVisible(false);
          }
        }
      })
      .then(data => {
        if (data.status === 1) {
          setConversionLogsConversionType(data.data.conversion_type);
          setConversionLogsGoalList(data.data.goal_list);
          setConversionLogsPostbackList(data.data.postback_list);
          setConversionLogsWebhookList(data.data.webhook_list || []);
          setConversionLogsVariationList(data.data.variation_list || []);
          setIsVisiLoaderVisible(false);
        } else {
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
          setIsVisiLoaderVisible(false);
          onConversionLogsClose();
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        setIsVisiLoaderVisible(false);
      });
    }
  }, [isConversionLogsModalOpen, pageId]);

  const conversionTypeData = conversionLogsConversionType.map((ConversionTypeData) => ({
      value: ConversionTypeData.id,
      label: ConversionTypeData.name,
    }));

  useEffect(() => {
    if (conversionLogsConversionType.length > 0) {
      const firstOption = conversionLogsConversionType[0];
      setConversionType(firstOption.id);
      setConversionTypeName(firstOption.name);
    }
  }, [conversionLogsConversionType]);

  const goalListData = [
    { value: '', label: 'Select Goal', disabled: true },
    ...conversionLogsGoalList.map((GoalListData) => ({
      value: GoalListData.page_id,
      label: GoalListData.page_title,
    })),
  ];

  const postbackListData = [
    { value: '', label: 'Select Postback', disabled: true },
    ...conversionLogsPostbackList.map((PostbackListData) => ({
      value: PostbackListData.postback_id,
      label: PostbackListData.postback_name,
    })),
  ];

  const webhookListData = [
    { value: '', label: 'Select Webhook', disabled: true },
    ...conversionLogsWebhookList.map((WebhookListData) => ({
      value: WebhookListData.webhook_id,
      label: WebhookListData.webhook_name,
    })),
  ];

  const variationListData = conversionLogsVariationList.map((VariationListData) => ({
    value: VariationListData.variation_id,
    label: VariationListData.variation_name,
  }));

  /* The variation filter only applies to defined webhook conversions, which is the
     only log view that resolves a variation per row. */
  const showVariationFilter = conversionTypeName === 'Defined Conversion' && convLogRedioBtn === 'webhook';

  // Export applies to defined webhook conversions only; the empty result is handled on click.
  const showWebhookExport = showVariationFilter;

  const handleConversionType = (value:any) => {
    const selectedOption = conversionTypeData.find((option) => option.value === value);
    setConversionType(value);
    setConversionTypeName(selectedOption ? selectedOption.label : '');
  };

  const handleSelectListChange = (value) => {
    if (convLogRedioBtn === 'goal') {
      const selectedOption = goalListData.find((option) => option.value === value);
      setGoalList(value);
      setGoalListName(selectedOption ? selectedOption.label : '');
    } else if (convLogRedioBtn === 'postback') {
      const selectedOption = postbackListData.find((option) => option.value === value);
      setPostbackList(value);
      setPostbackListName(selectedOption ? selectedOption.label : '');
    } else if (convLogRedioBtn === 'webhook') {
      const selectedOption = webhookListData.find((option) => option.value === value);
      setWebhookList(value);
      setWebhookListName(selectedOption ? selectedOption.label : '');
    }
  };

  const handleRadioChange = (value) => {
    setConvLogRedioBtn(value);
    setGoalList('');
    setPostbackList('');
    setWebhookList('');
    setVariationList('all');
  };

  const handlePageChange = (newPage) => {
    handleConversionDataLog('',newPage);
    setActivePageNo(newPage);
  };

  const handleConversionDataLog = (value:any,activePageNo:any) => {
    setIsVisiLoaderVisible(true);
    TestsApi.getconversionlogfilter({
      system_website_id: selectedMemberWebsite,
      funnel_first_page_id:pageId,
      conv_type:conversionType,
      type:"tests",
      conversion_log_time:selectedTimePicker,
      goal_name:goalListName,
      goal_type:convLogRedioBtn,
      conv_goal:goalList,
      page:activePageNo,
      conv_postback:postbackList,
      conv_webhook:webhookList,
      conv_variation:variationList,
      conversion_log_from:selectedTimePickerFromDate,
      conversion_log_to:selectedTimePickerToDate
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          setIsVisiLoaderVisible(false);
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        setUndefinedConversionTableField(data.data.conversion_field || []);
        setUndefinedConversionTableData(data.data.conversion_data || []);
        setDefinedConversionTableField(data.data.conversion_field || []);
        setDefinedConversionTableData(data.data.conversion_data || []);
        setResetConversionTableField(data.data.conversion_field || []);
        setResetConversionTableData(data.data.conversion_data || []);
        setConversionTypeStatus(data.data.conversion_type_status);
        setRecordUniqueConversionTableField(data.data.conversion_field || []);
        setRecordUniqueConversionTableData(data.data.conversion_data || []);
        setWebhookDefinedConversionTableField(data.data.conversion_field || []);
        setWebhookDefinedConversionTableData(data.data.conversion_data || []);
        setTrafficControlLogsData(data.data.conversion_data || []);
        setFilterConversionLog('yes');
        if (data.data.active_page_no !== activePageNo) {
          setActivePageNo(data.data.active_page_no);
          setActivePageNo(1);
        }
        if (data.data.total_pages !== totalPages) {
          setTotalPages(data.data.total_pages);
        }
        if (JSON.stringify(data.data.total_pagination_no) !== JSON.stringify(totalPaginationNo)) {
          setTotalPaginationNo(data.data.total_pagination_no);
        }
        setIsVisiLoaderVisible(false);
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
        setIsVisiLoaderVisible(false);
        onConversionLogsClose();
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setIsVisiLoaderVisible(false);
    });
  };

  const handleConversionLogsCloseModal = () => {
    onConversionLogsClose();
    setConversionType('');
    setGoalList('');
    setPostbackList('');
    setWebhookList('');
    setVariationList('all');
    setConversionLogsGoalList([]);
    setConversionLogsPostbackList([]);
    setConversionLogsWebhookList([]);
    setConversionLogsVariationList([]);
    setUndefinedConversionTableField([]);
    setUndefinedConversionTableData([]);
    setDefinedConversionTableField([]);
    setDefinedConversionTableData([]);
    setResetConversionTableField([]);
    setResetConversionTableData([]);
    setRecordUniqueConversionTableField([]);
    setRecordUniqueConversionTableData([]);
    setWebhookDefinedConversionTableField([]);
    setWebhookDefinedConversionTableData([]);
    setSelectedTimePicker('');
    setSelectedTimePickerToDate('');
    setSelectedTimePickerFromDate('');
    setActivePageNo(1);
    setTotalPages(0);
  };

  /* TIME PICKER AND DATE PICKER  */
    const handleselectedTimePickerComponentChange = (Value:any) => {
      setSelectedTimePicker(Value);
    }

    const handleselectedTimePickerToDateChange = (Value:any) => {
      setSelectedTimePickerToDate(Value);
    }

    const handleselectedTimePickerFromDateChange = (Value:any) => {
      setSelectedTimePickerFromDate(Value);
    }

    const getStartDate = () => {
      const [year, month, day] = testStartDate.split('-');
      return `${year}-${month}-${day}`;
    };

    const getSelectedFromDate = () => {
      if(selectedTimePickerFromDate){
        const [month, day, year] = selectedTimePickerFromDate.split('-');
        return `${year}-${month}-${day}`;
      }else{
        const [year, month, day] = testStartDate.split('-');
        return `${year}-${month}-${day}`;
      }
    };

    const getSelectedToDate = () => {
      if(selectedTimePickerToDate){
        const [month, day, year] = selectedTimePickerToDate.split('-');
        return `${year}-${month}-${day}`;
      }else{
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
    };
  /* END TIME PICKER AND DATE PICKER  */

  const handleHelpClick = (id:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    if (logsRef.current) {
      const { top, left, width } = logsRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        top: top + scrollOffset,
        left: left + width + 10, 
      });
    }
  };

  const handleMoveToSubscription = (webhook_id:any) => {
    setIsVisiLoaderVisible(true);
    TestsApi.movetosubscriptionamount({
      webhook_id: webhook_id
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          setIsVisiLoaderVisible(false);
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        handleConversionDataLog('',activePageNo);
        setIsVisiLoaderVisible(false);
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
        setIsVisiLoaderVisible(false);
        onConversionLogsClose();
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setIsVisiLoaderVisible(false);
    });
  };

  // The log table is server paged, so export refetches the whole filtered set in one call.
  const handleExportWebhookConversions = () => {
    setIsVisiLoaderVisible(true);
    TestsApi.getconversionlogfilter({
      system_website_id: selectedMemberWebsite,
      funnel_first_page_id:pageId,
      conv_type:conversionType,
      type:"tests",
      conversion_log_time:selectedTimePicker,
      goal_name:goalListName,
      goal_type:convLogRedioBtn,
      conv_goal:goalList,
      page:1,
      conv_postback:postbackList,
      conv_webhook:webhookList,
      conv_variation:variationList,
      conversion_log_from:selectedTimePickerFromDate,
      conversion_log_to:selectedTimePickerToDate,
      export:1
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          setIsVisiLoaderVisible(false);
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        const exportData = data.data.conversion_data || [];
        if (exportData.length === 0) {
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: 'No data available to export.',
          });
          setIsVisiLoaderVisible(false);
          return;
        }
        const escapeCsvValue = (value:any) => `"${String(value === null || value === undefined ? '' : value).replace(/"/g, '""')}"`;
        const exportRows = exportData.map((element:any) => [
          element.date,
          element.email,
          element.transaction_id,
          element.sales_amount,
          element.move_to_subscription,
          element.variation ? element.variation : 'N/A'
        ]);
        const csvContent = [data.data.conversion_field || [], ...exportRows]
          .map((row:any) => row.map(escapeCsvValue).join(','))
          .join('\n');
        const selectedWebhook = webhookListData.find((option:any) => option.value === webhookList);
        const safeWebhookName = String(selectedWebhook ? selectedWebhook.label : 'webhook')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
        const blob = new Blob(["﻿" + csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${safeWebhookName}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        setIsVisiLoaderVisible(false);
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
        setIsVisiLoaderVisible(false);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setIsVisiLoaderVisible(false);
    });
  };

  return (
    <>
      {showHelpModal &&
          ReactDOM.createPortal(
            <div>
              <SelectTooltip
                isVisible={showHelpModal}
                setIsVisible={setShowHelpModal}
                id={helpTargetId}
                tooltipPosition={tooltipPosition} 
              />
            </div>,
          document.body
      )}
      <Modal.Root opened={isConversionLogsModalOpen} onClose={handleConversionLogsCloseModal} size="80%" styles={{ content: { height: '80vh' } }} trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <VisiLoader VisiLoaderVisible={isVisiLoaderVisible} />
          <Modal.Header>
            <Modal.Title>CONVERSION LOG <IconHelp ref={logsRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(326)}/></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body h={350} style={{marginTop:5}}>
            <Group>
              <div style={{ display: 'flex' }}>
                <ActionIcon
                  variant="white"
                  size="lg"
                  title="Time Filter"
                >
                  <IconClockHour4 size="1.1rem" />
                </ActionIcon>
                <SelectTimePicker SelectTimePickerValue={selectedTimePicker} SelectTimePickerOnChange={handleselectedTimePickerComponentChange} SelectTimePickerFromDateOnChange={handleselectedTimePickerFromDateChange} SelectTimePickerToDateOnChange={handleselectedTimePickerToDateChange} SelectTestStartDate={getSelectedFromDate()} SelectTestEndDate={getSelectedToDate()}SelectStartDate={getStartDate()} SelectedPage='reviewing_test'/>
              </div>
              <Text>Conversion Type:</Text>
              <Select
                dropdownPosition="bottom"
                value={conversionType}
                searchable
                data={conversionTypeData}
                onChange={handleConversionType}
              />
              <Text style={{ display: conversionTypeName === "Reset Data" || conversionTypeName === "Traffic Control Logs" ? "none" : "block" }}>Conversion to:</Text>
              <Radio.Group
                name="ConGoalType"
                mb={10}
                value={convLogRedioBtn}
                onChange={(value) => handleRadioChange(value)}
                style={{ display: conversionTypeName === "Reset Data" || conversionTypeName === "Traffic Control Logs" ? "none" : "block" }}
              >
                <Group mt="xs">
                  <Radio value="goal" label="Goals" />
                  <Radio value="postback" label="Postbacks" />
                  <Radio value="webhook" label="Webhooks" />
                </Group>
              </Radio.Group>
              <Select
                dropdownPosition="bottom"
                withinPortal
                value={
                  convLogRedioBtn === 'goal' ? goalList :
                  convLogRedioBtn === 'postback' ? postbackList :
                  webhookList
                }
                onChange={handleSelectListChange}
                searchable
                data={
                  convLogRedioBtn === 'goal' ? goalListData :
                  convLogRedioBtn === 'postback' ? postbackListData :
                  webhookListData
                }
                style={{ display: conversionTypeName === "Reset Data" || conversionTypeName === "Traffic Control Logs" ? "none" : "block" }}
                ml={10}
              />
              {showVariationFilter &&
                <>
                  <Text>Variation:</Text>
                  <Select
                    dropdownPosition="bottom"
                    withinPortal
                    value={variationList}
                    onChange={(value) => setVariationList(value || 'all')}
                    searchable
                    data={variationListData}
                  />
                </>
              }
              <Button type="submit" size="sm" w={80} onClick={() => handleConversionDataLog('',activePageNo)}>
                Filter
              </Button>
              {showWebhookExport &&
                <Button size="sm" variant="light" disabled={isVisiLoaderVisible} onClick={handleExportWebhookConversions}>
                  Export
                </Button>
              }
            </Group>
            <Divider my="sm" />
            <Group style={{ display: conversionTypeName === "Undefined Conversion" && filterConversionLog === 'yes' ? "flex" : "none" }}>
              <Table striped highlightOnHover withBorder my={15} fontSize="xs">
                <thead>
                <tr>
                  {(undefinedConversionTableField.length > 0 ? undefinedConversionTableField : webhookDefinedConversionTableField).map(
                    (element, index) => (
                      <th key={index}>{element}</th>
                    )
                  )}
                </tr>
                </thead>
                <tbody>
                  {(undefinedConversionTableData.length > 0 || webhookDefinedConversionTableData.length > 0) ? (
                  <>
                    {undefinedConversionTableData.length > 0 && (
                      <>
                        {conversionTypeStatus === "pixel_goal_conversion" &&
                          undefinedConversionTableData.map((element, index) => (
                            <tr key={index}>
                              <td>{element.goal_name}</td>
                              <td>{element.total_undefined_conv}</td>
                            </tr>
                          ))}

                        {conversionTypeStatus === "undefined_goal_webhook_conversion" && (
                          undefinedConversionTableData.map((element, index) => (
                            <tr key={index}>
                              <td>{element.date}</td>
                              <td>{element.email}</td>
                              <td>{element.transaction_id}</td>
                              <td>{element.sales_amount}</td>
                              <td>{element.reason}</td>
                            </tr>
                          ))
                        )}

                        {conversionTypeStatus === "undefined_postback_conversion" && (
                          undefinedConversionTableData.map((element, index) => (
                            <tr key={index}>
                              <td>{element.date}</td>
                              <td>{element.email}</td>
                              <td>{element.transaction_id}</td>
                              <td>{element.sales_amount}</td>
                              <td>{element.reason}</td>
                            </tr>
                          ))
                        )}
                      </>
                    )}

                    {webhookDefinedConversionTableData.length > 0 && (
                      <>
                        {conversionTypeStatus === "undefined_webhook_conversion" &&
                          webhookDefinedConversionTableData.map((element, index) => (
                            <tr key={index}>
                              <td>{element.date}</td>
                              <td>{element.email}</td>
                              <td>{element.transaction_id}</td>
                              <td>{element.sales_amount}</td>
                              <td>{element.subscription_amount}</td>
                              <td>{element.reason}</td>
                            </tr>
                          ))}

                        {conversionTypeStatus === "defined_webhook_conversion" &&
                          webhookDefinedConversionTableData.map((element, index) => (
                            <tr key={index}>
                              <td>{element.date}</td>
                              <td>{element.email}</td>
                              <td>{element.transaction_id}</td>
                              <td>{element.sales_amount}</td>
                              <td>
                                {element.move_to_subscription === "0.00" ? (
                                  <button onClick={() => handleMoveToSubscription(element.email_webhook_id)} style={{ backgroundColor: "#2fba6f", color: "#ffffff", cursor: "pointer", padding: "10px 10px", fontSize: "16px", border: "none", borderRadius: "4px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <span>Move to Subscription</span>
                                  </button>
                                ) : (
                                  element.move_to_subscription
                                )}
                              </td>
                              <td>{element.variation ? element.variation : 'N/A'}</td>
                            </tr>
                          ))}
                      </>
                    )}
                  </>
                ) : (
                  <tr>
                    <td colSpan={Math.max(undefinedConversionTableField.length, webhookDefinedConversionTableField.length)} style={{ textAlign: 'center' }}>
                      No Data Found
                    </td>
                  </tr>
                )}
                </tbody>
              </Table>
            </Group>
            <Group style={{ display: conversionTypeName === "Defined Conversion" && filterConversionLog === 'yes' ? "flex" : "none" }}>          
              <Table striped highlightOnHover withBorder my={15} fontSize="xs">
                <thead>
                  <tr>
                    {(definedConversionTableField.length > 0 ? definedConversionTableField : webhookDefinedConversionTableField).map(
                      (element, index) => (
                        <th key={index}>{element}</th>
                      )
                    )}
                  </tr>
                </thead>
                <tbody>
                {(definedConversionTableData.length > 0 || webhookDefinedConversionTableData.length > 0) ? (
                  <>
                    {definedConversionTableData.length > 0 && (
                      <>
                        {conversionTypeStatus === "pixel_goal_conversion" &&
                          definedConversionTableData.map((element, index) => (
                            <tr key={index}>
                              <td>{element.goal_name}</td>
                              <td>{element.total_undefined_conv}</td>
                            </tr>
                          ))}

                        {conversionTypeStatus === "defined_goal_webhook_conversion" &&
                          definedConversionTableData.map((element, index) => (
                            <tr key={index}>
                              <td>{element.date}</td>
                              <td>{element.email}</td>
                              <td>{element.transaction_id}</td>
                              <td>{element.sales_amount}</td>
                            </tr>
                          ))}

                        {conversionTypeStatus === "defined_postback_conversion" && (
                          definedConversionTableData.map((element, index) => (
                            <tr key={index}>
                              <td>{element.date}</td>
                              <td>{element.email}</td>
                              <td>{element.transaction_id}</td>
                              <td>{element.sales_amount}</td>
                            </tr>
                          ))
                        )}
                      </>
                    )}

                    {webhookDefinedConversionTableData.length > 0 && (
                      <>
                        {conversionTypeStatus === "undefined_webhook_conversion" &&
                          webhookDefinedConversionTableData.map((element, index) => (
                            <tr key={index}>
                              <td>{element.date}</td>
                              <td>{element.email}</td>
                              <td>{element.transaction_id}</td>
                              <td>{element.sales_amount}</td>
                              <td>{element.subscription_amount}</td>
                              <td>{element.reason}</td>
                            </tr>
                          ))}

                        {conversionTypeStatus === "defined_webhook_conversion" &&
                          webhookDefinedConversionTableData.map((element, index) => (
                            <tr key={index}>
                              <td>{element.date}</td>
                              <td>{element.email}</td>
                              <td>{element.transaction_id}</td>
                              <td>{element.sales_amount}</td>
                              <td>
                                {element.move_to_subscription === "0.00" ? (
                                  <button onClick={() => handleMoveToSubscription(element.email_webhook_id)} style={{ backgroundColor: "#2fba6f", color: "#ffffff", cursor: "pointer", padding: "10px 10px", fontSize: "16px", border: "none", borderRadius: "4px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <span>Move to Subscription</span>
                                  </button>
                                ) : (
                                  element.move_to_subscription
                                )}
                              </td>
                              <td>{element.variation ? element.variation : 'N/A'}</td>
                            </tr>
                          ))}
                      </>
                    )}
                  </>
                ) : (
                  <tr>
                    <td colSpan={Math.max(definedConversionTableField.length, webhookDefinedConversionTableField.length)} style={{ textAlign: 'center' }}>
                      No Data Found
                    </td>
                  </tr>
                )}
                </tbody>
              </Table>
            </Group>
            <Group style={{ display: conversionTypeName === "Reset Data" && filterConversionLog === 'yes' ? "flex" : "none" }}>
              <Table striped highlightOnHover withBorder my={15} fontSize="xs">
                <thead>
                  <tr>
                    {resetConversionTableField.map((element, index) => (
                      <th key={index}>{element}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {
                    resetConversionTableData.length > 0 ? (
                      <>
                        {conversionTypeStatus === "reset_conversion" && (
                          resetConversionTableData.map((element, index) => (
                            <tr key={index}>
                              <td>{element.action}</td>
                              <td>{element.date}</td>
                              <td>{element.email}</td>
                            </tr>
                          ))
                        )}
                      </>
                    ) : (
                      <tr>
                        <td colSpan={resetConversionTableField.length} style={{ textAlign: 'center' }}>No Data Found</td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            </Group>
            <Group style={{ display: conversionTypeName === "Record Unique/All Conversion" && filterConversionLog === 'yes' ? "flex" : "none" }}>
              <Table striped highlightOnHover withBorder my={15} fontSize="xs">
                <thead>
                  <tr>
                    {recordUniqueConversionTableField.map((element, index) => (
                      <th key={index}>{element}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {
                    recordUniqueConversionTableData.length > 0 ? (
                      <>
                        {conversionTypeStatus === "record_unique_all_conversion" && (
                          recordUniqueConversionTableData.map((element, index) => (
                            <tr key={index}>
                              <td>{element.action}</td>
                              <td>{element.date}</td>
                              <td>{element.email}</td>
                            </tr>
                          ))
                        )}
                      </>
                    ) : (
                      <tr>
                        <td colSpan={recordUniqueConversionTableField.length} style={{ textAlign: 'center' }}>No Data Found</td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            </Group>
            <Group style={{ display: conversionTypeName === "Traffic Control Logs" && filterConversionLog === 'yes' ? "flex" : "none" }}>
              <Table striped highlightOnHover withBorder my={15} fontSize="xs">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Traffic Control Ratio</th>
                    <th>Auto Adjust</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    trafficControlLogsData.length > 0 ? (
                      <>
                        {conversionTypeStatus === "traffic_control_logs" && (
                          trafficControlLogsData.map((element, index) => (
                            <tr key={index}>
                              <td>{element.date}</td>
                              <td><Text size="sm" dangerouslySetInnerHTML={{ __html: element.test_ratio }} /></td>
                              <td>{element.auto_adjust}</td>
                            </tr>
                          ))
                        )}
                      </>
                    ) : (
                      <tr>
                        <td colSpan={3} style={{ textAlign: 'center' }}>No Data Found</td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            </Group>
            {filterConversionLog === 'yes' && totalPages && totalPages > 1 ?
            <Pagination.Root total={totalPages} value={activePageNo} onChange={handlePageChange}>
              <Group spacing={5} position="center">
                <Pagination.First />
                <Pagination.Previous />
                <Pagination.Items />
                <Pagination.Next />
                <Pagination.Last />
              </Group>
            </Pagination.Root> : ''}
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
}